import { takeLatest, all } from 'redux-saga/effects';
import {
    handleLoadViajes,
    handleLoadViaje,
    handleRefreshViajeGps,
    handleSaveViaje,
    handleLoadViajeFiles,
    handleRefreshCombustible,
    handleDeleteCombustible,
    handleRemoveCaseta,
    handleRefreshCasetas,
    calcularRendimientoViaje,
} from './handlers/viajes';
import {
    LOAD_VIAJES,
    LOAD_VIAJE,
    SAVE_VIAJE,
    LOAD_VIAJE_FILES,
    REFRESH_VIAJE_CASETAS,
    REFRESH_COMBUSTIBLE,
    REMOVE_COMBUSTIBLE,
    REMOVE_CASETA,
    REFRESH_VIAJE_GPS,
    CALCULAR_RENDIMIENTO_VIAJE,
} from '../ducks/viajes';
import { LOAD_OPERADORES, SAVE_OPERADOR } from '../ducks/operadores';
import { LOAD_UNIDADES, SAVE_UNIDAD } from '../ducks/unidades';
import { LOAD_FACTURAS, SAVE_FACTURA } from '../ducks/facturas';
import { LOAD_CLIENTES, SAVE_CLIENTE } from '../ducks/clientes';
import { LOAD_BANCOS, SAVE_BANCO } from '../ducks/bancos';
import {
    LOAD_CLASIFICACION_MOVIMIENTOS,
    SAVE_CLASIFICACION_MOVIMIENTO,
} from '../ducks/clasificacionMovimientos';
import {
    LOAD_GENERIC_PARAMETERS,
    SAVE_GENERIC_PARAMETER,
} from '../ducks/genericParameters';
import {
    LOAD_CONTROL_INGRESOS,
    SAVE_CONTROL_INGRESO,
} from '../ducks/controlIngresos';
import { LOAD_CUENTAS_BANCARIAS, SAVE_CUENTA_BANCARIA } from '../ducks/cuentasBancarias';
import { LOAD_MOVIMIENTOS_BANCARIOS, SAVE_MOVIMIENTO_BANCARIO } from '../ducks/movimientosBancarios';
import { LOAD_GASOLINAS, SAVE_GASOLINA } from '../ducks/gasolinas';
import { LOAD_CASETAS_NEW } from '../ducks/casetas_New';
import { LOAD_CASETAS_LIQ } from '../ducks/casetasLiq';
import { LOAD_TRAMOS } from '../ducks/tramos';
import { LOAD_GPSALL } from '../ducks/gpsall';
import {
    LOAD_MTTO,
    SAVE_MTTO,
    LOAD_MTTO_HISTORIAL,
} from '../ducks/mttos';
import {
    LOAD_REGISTRO_MATERIALES,
    SAVE_REGISTRO_MATERIAL,
} from '../ducks/registroMateriales';
import {
    handleLoadOperadores,
    handleSaveOperador,
} from './handlers/operadores';
import { handleLoadUnidades, handleSaveUnidad } from './handlers/unidades';
import { handleLoadFacturas, handleSaveFactura } from './handlers/facturas';
import { handleLoadClientes, handleSaveCliente } from './handlers/clientes';
import { handleLoadBancos, handleSaveBanco } from './handlers/bancos';
import { handleLoadCuentasBancarias, handleSaveCuentaBancaria } from './handlers/cuentasBancarias';
import { handleLoadMovimientosBancarios, handleSaveMovimientoBancario } from './handlers/movimientosBancarios';
import { handleLoadGasolinas, handleSaveGasolina } from './handlers/gasolinas';
import handleLoadCasetasNew from './handlers/casetas_New';
import handleLoadCasetasLiq from './handlers/casetasLiq';
import handleLoadTramos from './handlers/tramos';
import handleLoadGpsall from './handlers/gpsall';
import { handleLoadMtto, handleSaveMtto, handleLoadMttoHistorial } from './handlers/mttos';
import {
    handleLoadRegistroMateriales,
    handleSaveRegistroMaterial,
} from './handlers/registroMateriales';
import {
    handleLoadClasificacionMovimientos,
    handleSaveClasificacionMovimiento,
} from './handlers/clasificacionMovimientos';
import {
    handleLoadGenericParameters,
    handleSaveGenericParameter,
} from './handlers/genericParameters';
import {
    handleLoadControlIngresos,
    handleSaveControlIngreso,
} from './handlers/controlIngresos';

export default function* watcherSaga() {
    yield all([
        yield takeLatest(LOAD_VIAJES, handleLoadViajes),
        yield takeLatest(LOAD_VIAJE, handleLoadViaje),
        yield takeLatest(SAVE_VIAJE, handleSaveViaje),
        yield takeLatest(LOAD_OPERADORES, handleLoadOperadores),
        yield takeLatest(SAVE_OPERADOR, handleSaveOperador),
        yield takeLatest(LOAD_VIAJE_FILES, handleLoadViajeFiles),
        yield takeLatest(LOAD_UNIDADES, handleLoadUnidades),
        yield takeLatest(SAVE_UNIDAD, handleSaveUnidad),
        yield takeLatest(LOAD_FACTURAS, handleLoadFacturas),
        yield takeLatest(SAVE_FACTURA, handleSaveFactura),
        yield takeLatest(LOAD_CLIENTES, handleLoadClientes),
        yield takeLatest(SAVE_CLIENTE, handleSaveCliente),
        yield takeLatest(LOAD_BANCOS, handleLoadBancos),
        yield takeLatest(SAVE_BANCO, handleSaveBanco),
        yield takeLatest(LOAD_CUENTAS_BANCARIAS, handleLoadCuentasBancarias),
        yield takeLatest(SAVE_CUENTA_BANCARIA, handleSaveCuentaBancaria),
        yield takeLatest(LOAD_MOVIMIENTOS_BANCARIOS, handleLoadMovimientosBancarios),
        yield takeLatest(SAVE_MOVIMIENTO_BANCARIO, handleSaveMovimientoBancario),
        yield takeLatest(LOAD_GASOLINAS, handleLoadGasolinas),
        yield takeLatest(SAVE_GASOLINA, handleSaveGasolina),
        yield takeLatest(LOAD_CASETAS_NEW, handleLoadCasetasNew),
        yield takeLatest(LOAD_CASETAS_LIQ, handleLoadCasetasLiq),
        yield takeLatest(LOAD_TRAMOS, handleLoadTramos),
        yield takeLatest(LOAD_GPSALL, handleLoadGpsall),
        yield takeLatest(REFRESH_COMBUSTIBLE, handleRefreshCombustible),
        yield takeLatest(REMOVE_COMBUSTIBLE, handleDeleteCombustible),
        yield takeLatest(REMOVE_CASETA, handleRemoveCaseta),
        yield takeLatest(REFRESH_VIAJE_GPS, handleRefreshViajeGps),
        yield takeLatest(REFRESH_VIAJE_CASETAS, handleRefreshCasetas),
        yield takeLatest(CALCULAR_RENDIMIENTO_VIAJE, calcularRendimientoViaje),
        yield takeLatest(LOAD_MTTO, handleLoadMtto),
        yield takeLatest(SAVE_MTTO, handleSaveMtto),
        yield takeLatest(LOAD_REGISTRO_MATERIALES, handleLoadRegistroMateriales),
        yield takeLatest(SAVE_REGISTRO_MATERIAL, handleSaveRegistroMaterial),
        yield takeLatest(LOAD_MTTO_HISTORIAL, handleLoadMttoHistorial),
        yield takeLatest(LOAD_CLASIFICACION_MOVIMIENTOS, handleLoadClasificacionMovimientos),
        yield takeLatest(SAVE_CLASIFICACION_MOVIMIENTO, handleSaveClasificacionMovimiento),
        yield takeLatest(LOAD_GENERIC_PARAMETERS, handleLoadGenericParameters),
        yield takeLatest(SAVE_GENERIC_PARAMETER, handleSaveGenericParameter),
        yield takeLatest(LOAD_CONTROL_INGRESOS, handleLoadControlIngresos),
        yield takeLatest(SAVE_CONTROL_INGRESO, handleSaveControlIngreso),
    ]);
}
